import { CONTACTS_SECTION } from '@/features/settingsPage/consts/sections';
import { getSectionUrl } from '@/features/settingsPage/structs/section';

export { RESOURCE_NAME } from '@esentai/core/features/questions/consts';

export const ROUTE_PATH = getSectionUrl(CONTACTS_SECTION);

export const FEATURE_NAME = 'contactsEditPage';
